<rask-page
    pageTitle="Sök transportföretag"
    noPadding>
    <ng-container headerContent>
        <form [formGroup]="transportforetagForm" (ngSubmit)="search()">
            <div class="row">
                <rask-input aid="inputSearchtext" class="col-2" label="Transportföretag, namn eller organisationsnummer"
                    formControlName="searchtext" [rule]="">
                </rask-input>
                <div class="col">
                    <rask-radiobutton-group aid="radioActive" label="Aktiv" [buttons]="activetypes"
                        formControlName="active" [rule]=""></rask-radiobutton-group>
                    <rask-submit-button aid="buttonSok" color="secondary">Sök</rask-submit-button>
                </div>
            </div>
        </form>
    </ng-container>
    <rask-transportforetag-list [transportforetag]="transportforetag"></rask-transportforetag-list>
</rask-page>